/**
 * GraphQL Query to get gift options list
 * */

export default `
  mutation setClickAndCollectShop($cartId: String!, $externalId: String!) {
    setClickAndCollectShop(
      cart_id: $cartId,
      external_id: $externalId
    )
  }
`;
